import { HTTP } from '../helpers/http-common.js'
import authHeader from '../helpers/auth-header'
import helpers from '../helpers/helpers'


const brandsService = {
    getBrands,
    storeBrand,
    updateBrand,
    getBrand,
    deleteBrand
};

export default brandsService

function getBrands(page = 0, search = {}) {

  let params = '';
  
  if(search.term) {
    params += `&search=${search.term}`;
  }

  if(search.options) {
    params += `&options=${search.options}`
  }

  if(search.perPage) {
    params += `&perPage=${search.perPage}`
  }

  return HTTP.get(`brands?page=${page}${params}`, {
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}

function getBrand(id) {
  return HTTP.get(`brand/${id}`, {
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()

    }
  });
}

function storeBrand(item = {}) {
  return HTTP({
    method: 'post',
    url: 'store-brand',
    data: item,
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()

    }
  });
}

function updateBrand(item = {}) {
  return HTTP({
    method: 'post',
    url: 'update-brand',
    data: item,
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}

function deleteBrand(id) {
  return HTTP({
    method: 'post',
    url: 'delete-brand',
    data: {id: id},
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}